export interface Breakpoints {
  laptop: string;
  desktop: string;
}

export const breakpoints: Breakpoints = {
  laptop: '768px',
  desktop: '1920px'
};
